<pk-web-loader [show]="loading"></pk-web-loader>
@if (!loading) {
	<div class="row">
		<div class="col logo-crawl">
			<div class="logo-crawl-inner">
				@for (supplier of webSupplierMetrics; track supplier) {
					<img [src]="supplier.logo" class="img-fluid" [attr.alt]="supplier.name" />
				}
			</div>
		</div>
	</div>
}
